import https from "./axiosCurd";
import { getToken, logOut } from "./util.js";
import _ from "lodash";

const create = (url, data, keyHeaders) => {
  // return https.post(url,data,{});
  return new Promise((resolve, reject) => {
    https
      .post(url, data, {
        headers: keyHeaders
          ? {
              Authorization:
                getToken() != undefined ? "Bearer " + getToken() : "",
              "Content-Type": "multipart/form-data",
            }
          : {
              Authorization:
                getToken() != undefined ? "Bearer " + getToken() : "",
            },
      })
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        //alert(_.get(error, "response.data.detail.code",""))

        if (
          ["LOGOUT_ACCOUNT", "LOGIN_TOKEN_EXPIRED", "INVALIED_TOKEN"].indexOf(
            _.get(error, "response.data.detail.code", "")
          ) > -1
        ) {
          logOut();
          window.location.href = "/sessionTimeout";
        }
        reject(error);
      });
  });
};

const uploadFile = (url, data) => {
  return https.post(url, data, {
    headers: {
      Authorization: getToken() != undefined ? "Bearer " + getToken() : "",
      "Content-Type": "multipart/form-data",
    },
  });
};
const get = (url, response_type = "") => {
  if (response_type == "") {
    // return https.get(url);
    return https.get(url, {
      headers: {
        Authorization: getToken() != undefined ? "Bearer " + getToken() : "",
      },
    });
  } else {
    // return https.get(url,{responseType:response_type});
    return https.get(url, {
      headers: {
        Authorization: getToken() != undefined ? "Bearer " + getToken() : "",
        responseType: response_type,
      },
    });
  }
};
const put = (url, data) => {
  // return https.put(url,data,{})
  return https.put(url, data, {
    headers: {
      Authorization: "Bearer " + getToken(),
    },
  });
};
const updatePassword = (url, data) => {
  
  return new Promise((resolve, reject) => {
    https
      .post(url, data, {
        headers: {
              Authorization:
                "Bearer " +data.token,
            },
      })
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        reject(error);
      });
  });
};
export default { create, get, put, uploadFile,updatePassword };
